import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import {
  Observable,
  catchError,
  throwError,
} from "rxjs";
import { GeoLocationService } from "../_services/geoLocation.service";
import { LocalStorageService } from "../_services/localStorage.service";
import { environment } from "src/environments/environment";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  url = `${environment.apiUrl}`;
  constructor(
    private localStorageService: LocalStorageService,
    private geoLocationService: GeoLocationService,
    private router: Router
  ) {
    this.subscribeRoutes();
  }
  currentRoute!: string;
  exactExeptionRoutes = [""];
  startWithExeptionRoutes = ["/verifier-numero-telephone"];
  excludedApis = ["https://api.stripe.com"]; // Add Stripe API endpoint here

  isRouteException(url: string): boolean {
    if (this.exactExeptionRoutes.includes(url)) {
      return true;
    }
    for (let route of this.startWithExeptionRoutes) {
      if (url?.startsWith(route)) {
        return true;
      }
    }
    for (let excludedApi of this.excludedApis) {
      if (url?.startsWith(excludedApi)) {
        return true;
      }
    }

    return false;
  }
  isApiException(url: string): boolean {
    for (let excludedApi of this.excludedApis) {
      if (url?.startsWith(excludedApi)) {
        return true;
      }
    }
    return false;
  }
  subscribeRoutes() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.urlAfterRedirects;
      }
    });
  }
    intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let currentUser = this.localStorageService.getToken();
    const reqUrl = request.url;
    
    if (currentUser && !this.isApiException(reqUrl)) {
      if (reqUrl == `${this.url}/frontoffice/refresh-token`) {
        currentUser = this.localStorageService.getRefreshToken();
      }
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser}`,
        },
      });
    }

    return next.handle(request).pipe(
      catchError((err: any) => {
        return throwError(err);
      })
    );
  }



}
